export default "__VITE_ASSET__7b2ef76c__"